
export enum FeedbackState {
    REACTION_INPUT = 'reaction-input',
    TEXT_INPUT = 'text-input',
    SUBMITTED = 'submitted',
}

export enum FeedbackReaction {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
}